export default "__VITE_ASSET__CQgC_WvS__"